export default __webpack_public_path__ + "static/media/photocopy.d16816d2.svg";